import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/Home';
import Company from './pages/Company';
import Munck from './pages/Munck';
import Crane from './pages/Crane';
import EquipmentDetail from './pages/EquipmentDetail';
import Contact from './pages/Contact';
import Photos from './pages/Photos';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quem-somos" element={<Company />} />
            <Route path="/munck" element={<Munck />} />
            <Route path="/munck/:slug" element={<EquipmentDetail />} />
            <Route path="/guindaste" element={<Crane />} />
            <Route path="/guindaste/:slug" element={<EquipmentDetail />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/portfolio" element={<Photos />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;
